// extracted by mini-css-extract-plugin
export default {"landingPage":"Campaign2_landingPage__Say+z","landingImg":"Campaign2_landingImg__PiMkp","tcButton":"Campaign2_tcButton__RslVa"};